import React from 'react';
import {
  BrowserRouter as Router,
  Prompt,
  Route,
  Switch,
} from 'react-router-dom';
import { useSelector } from 'react-redux';

import Configurator from 'components/configurator/Configurator';
import Project from 'components/projects/Project';
import { READ } from './services/users/permissionTypes';

import Permission from './components/layout/Permission';
import Projects from './components/projects/Projects';
import Home from './components/Home';
import Layout from './components/layout/Layout';

import 'style/theme.css';

const App = (): JSX.Element | null => {
  const user = useSelector((state: any) => state.users.current);
  const configuratorHasChanged = useSelector(
    (state: any) => state.configurationChange
  );

  if (user === null) {
    return (
      <Layout>
        <div />
      </Layout>
    );
  }

  const configuratorHasChanges = (location: any, action: any) => {
    console.log('prompt', location.pathname);
    return configuratorHasChanged
      ? 'Are you sure you want to leave? You have unsaved changes.'
      : true;
  };

  return (
    <Router>
      <Layout>
        <Switch>
          <Route exact path="/">
            <Permission permissions={[READ]}>
              <Home />
            </Permission>
          </Route>

          <Route exact path="/projects">
            <Permission permissions={[READ]}>
              <Projects />
            </Permission>
          </Route>

          <Route exact path="/projects/:projectId">
            <Permission permissions={[READ]}>
              <Project />
            </Permission>
          </Route>

          <Route exact path="/projects/:projectId/configuration">
            <Prompt message={configuratorHasChanges} />
            <Permission permissions={[READ]}>
              <Configurator />
            </Permission>
          </Route>

          <Route exact path="/configurations/:configurationId">
            <Prompt message={configuratorHasChanges} />
            <Permission permissions={[READ]}>
              <Configurator />
            </Permission>
          </Route>
        </Switch>
      </Layout>
    </Router>
  );
};

export default App;
